<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            Result Api Users List
          </span>
          <v-btn
            small
            color="primary"
            :to="{ name: $routes.admin.resultApiUser.createRoute.name }"
          >
            Create User
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="loading"
            :headers="tableColumns"
            :items="users"
          >
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="editUser(item)">
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { fetchUsers } from "../../../../api/resultApiUser.api.js";
import ContentLoader from "../../../mixins/ContentLoader.js";

export default {
  name: "ResultApiUserIndex",
  mixins: [ContentLoader],
  data() {
    return {
      users: [],
      tableColumns: [
        {
          text: "Username",
          value: "username"
        },
        {
          text: "Domain",
          value: "domain"
        },
        {
          text: "Server",
          value: "server.domain"
        },
        {
          text: "Actions",
          value: "action"
        }
      ]
    };
  },
  async mounted() {
    this.$startLoading();

    try {
      const result = await fetchUsers(),
        { users } = result.data;

      this.users = users;

      await this.$nextTick();
    } catch (e) {
      console.error(e);
    } finally {
      this.$finishedLoading();
    }
  },
  methods: {
    editUser({ id }) {
      this.$router.push({
        name: this.$routes.admin.resultApiUser.editRoute.name,
        params: { id }
      });
    }
  }
};
</script>

<style scoped></style>
